module.exports = __webpack_public_path__ + "static/media/hero03.c662987c.mp4";